import { render, staticRenderFns } from "./item-text.vue?vue&type=template&id=42968c18&scoped=true&lang=pug&"
import script from "./item-text.vue?vue&type=script&lang=ts&"
export * from "./item-text.vue?vue&type=script&lang=ts&"
import style0 from "./item-text.vue?vue&type=style&index=0&id=42968c18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../comm-comp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42968c18",
  null
  
)

export default component.exports